import { DocumentsTable } from '@/components/documents/DocumentsTable'
import { SkeletonRows } from '@/components/ui/skeleton'
import { useLeadDocuments } from '@/models/document'
import { type SalesLead } from '@/models/salesLead'

interface DocumentsTabProps {
  lead: SalesLead
}

export function DocumentsTab({ lead }: DocumentsTabProps) {
  const { data: documents = [], isLoading } = useLeadDocuments(lead.id)

  if (isLoading) {
    return <SkeletonRows rows={4} className="p-4" />
  }

  return (
    <div className="p-2">
      <DocumentsTable documents={documents} />
    </div>
  )
}
